import { USER_TYPE } from "@constants/Enums";
import { USER } from "@types/user";

const BlankUser: USER = {
  id: 0,
  uid: "",
  user_type: USER_TYPE.INTERNAL,
  employee_number: "",
  first_furigana_name: "",
  last_furigana_name: "",
  first_name: "",
  last_name: "",
  department_name: "",
  name: "",
  tenant_code: localStorage.getItem("realm"),
  kana_name: "",
  furigana_name: "",
  email: "",
  profile_image_url: "",
  login_id: "",
  login_password: "",
  is_display: true,
  card_image_urls: [],
  company_name: "",
  company_tel: "",
  personal_tel: "",
  created_at: "",
  company_address: "",
  company_home_page: "",
  date_of_receiving_info: "",
};

export default BlankUser;
